import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["aria-expanded", "onKeydown"]
const _hoisted_2 = { class: "flex flex-col gap-2.5 px-6 pb-5 pt-3 basis-full rounded-md border-solid border-2 border-racq-white" }
const _hoisted_3 = { class: "flex gap-4 rounded" }
const _hoisted_4 = { class: "flex flex-col justify-center basis-9 shrink-0" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex flex-col justify-center ml-auto payment-confirmation__proposition-expander" }
const _hoisted_7 = { class: "flex flex-col justify-center ml-auto" }
const _hoisted_8 = {
  key: 0,
  class: "mt-2.5"
}

import { ref, computed } from 'vue';
import {
  IDecisionIntelligenceOfferResponse,
  IProposition,
  IStep,
} from '@/interfaces/decision-intelligence/decision-intelligence-response';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import ShowHideButton from '../ShowHideButton/ShowHideButton.vue';
// Define props and emitters
// ------------------------------------------------------------- //

export default /*@__PURE__*/_defineComponent({
  __name: 'DecisionIntelligenceOfferReminder',
  props: {
    decisionOffer: {},
    stepTitle: {},
    isRenewal: { type: Boolean },
    isQuote: { type: Boolean },
    isCrossSell: { type: Boolean },
    expandedByDefault: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

// Reactive state
const expanded = ref(props.expandedByDefault);

// Computed properties
const hasIncentivisedProposition = computed(() => props.decisionOffer?.propositions?.some((x) => x.incentivised));

const journeyType = computed(() => {
  if (props.isRenewal) return 'Make a payment';
  if (props.isQuote) return 'Quote';
  return 'Purchase';
});

const filterStep = computed<IStep | null>(() => {
  const proposition = props.decisionOffer?.propositions?.find((x) => x.incentivised);
  return (
    proposition?.displaySteps?.find(
      (x) => x.stepName === props.stepTitle && x.journey === journeyType.value && x.isCrossSell === props.isCrossSell
    ) || null
  );
});

// Methods
const toggleExpand = () => {
  expanded.value = !expanded.value;
};

const getFilterStep = (): IStep => {
  const proposition = props.decisionOffer?.propositions?.filter((x) => x.incentivised)[0];
  return (
    proposition?.displaySteps?.filter(
      (x) =>
        x.stepName == props.stepTitle &&
        x.journey == (props.isRenewal ? 'Make a payment' : props.isQuote ? 'Quote' : 'Purchase') &&
        x.isCrossSell == props.isCrossSell
    )[0] ?? ({} as IStep)
  );
};

return (_ctx: any,_cache: any) => {
  return (hasIncentivisedProposition.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "py-3 px-5 md:px-6 rounded border-2 border-racq-white shadow-md w-full my-8 md:my-6",
        "aria-expanded": expanded.value,
        role: "button",
        tabindex: "0",
        onClick: toggleExpand,
        onKeydown: [
          _withKeys(toggleExpand, ["enter"]),
          _withKeys(_withModifiers(toggleExpand, ["prevent"]), ["space"])
        ]
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: getFilterStep().imageUrl,
                Width: "40",
                Height: "30",
                alt: "offer image",
                class: "max-w-none h-7"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(expanded.value ? 'text-racq-blue font-bold text-base-bold pt-1.5' : 'text-base-bold pt-1.5')
            }, [
              _createVNode(_unref(RichText), {
                field: { value: getFilterStep().headerText }
              }, null, 8, ["field"])
            ], 2),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(ShowHideButton, {
                showMore: expanded.value,
                hideLabel: true,
                appendClass: "!mt-0",
                onClick: toggleExpand
              }, null, 8, ["showMore"])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(expanded.value ? 'text-racq-blue font-bold text-base-bold my-2 md:my-0' : 'text-base-bold my-2 md:my-0')
          }, [
            _createVNode(_unref(RichText), {
              field: { value: filterStep.value?.headerText || '' }
            }, null, 8, ["field"])
          ], 2),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(), _createElementBlock("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
              class: _normalizeClass([expanded.value ? 'scale-y-[-1]' : 'scale-y-100', "transition-transform duration-200"])
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("path", {
                d: "M1 4L8 11L15 4",
                stroke: "#0864BC",
                "stroke-width": "2"
              }, null, -1)
            ]), 2))
          ])
        ]),
        (expanded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(RichText), {
                class: "text-base",
                field: { value: filterStep.value?.messageText || '' }
              }, null, 8, ["field"])
            ]))
          : _createCommentVNode("", true)
      ], 40, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})